export const API_ERROR_CODE = {
  INTERNAL_SERVER_ERROR: -1,
  DATA_IS_NULL: -2,
  DB_API_ERROR: -3,
  DATA_IS_INVALID: -4,
  DATA_HAVE_NO_REQUIRED: -5,
  DATA_HAVE_EXCLUSIVE: -6,
  DATA_ALREADY_EXIST: -7,

  PERMISSION_INVALID: -21,

  TOKEN_EXPIRED: -31,
  TOKEN_INVALID: -32,

  USER_INVALID: -121,
  USER_NAME_EXiST: -122,

  BUSINESSES_CODE_EXIST: -150,
  BUSINESSES_CODE_INVALID: -151,

  INVITE_CODE_INVALID: -180,
  INVITE_CODE_EXPIRED: -181,
  INVITE_TYPE_INVALID: -182,

  PERMISSION_DENIED: -190,
};

export const API_SUCCESS_CODE = {
  API_SUCCESS: 0,
};
